import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ButtonNavStyled } from '../Styles';

export const ButtonNav = ({ expressionId, onClick, ...rest }) => {
  return (
    <ButtonNavStyled onClick={onClick} {...rest}>
      <FontAwesomeIcon icon={faChevronLeft} />
      {!!expressionId && <FormattedMessage id={expressionId} />}
    </ButtonNavStyled>
  );
};

ButtonNav.propTypes = {
  expressionId: PropTypes.string,
  onClick: PropTypes.func,
};
